import React, { useState, useEffect, useRef } from "react"

import "./ModelSelector.scss"


function ModelSelector({matrices = [], getModel}) {
    
    const [menu, displayMenu] = useState(false)
    const [matrix, setMatrix] = useState(matrices[0].name)

    const toggle = () => displayMenu(!menu)

    const selectMatrix = (item) => {
        setMatrix(item.name)
        getModel(item.name)
        toggle()     
    }

    let dropdownRef = useRef()

    useEffect(() => {
  
      let handler = (event) => {
        if (!dropdownRef.current.contains(event.target)) {
          displayMenu(false)
        }
      }
      document.addEventListener("mousedown", handler)
  
      return () => {
        document.removeEventListener("mousedown", handler)
      }
  
    })

    let itemsFiltered = matrices.filter(item => item.name !== matrix)
    
    return (
        <div ref={dropdownRef} className="ModelSelector">
            <div className="DropdownModel" onClick={toggle}>
                <div className="TopOptionModel">
                    <h3 className="OptionSelectedModel">{matrix}</h3>
                </div>

                <div className={menu ? "MatrixList" : "MatrixList_hidden"}>
                    <ul>
                        {itemsFiltered.map(item => (
                            <li className="Option" key={item.id} onClick={() => selectMatrix(item)}>
                                <h3 className="OptionName">{item.name}</h3>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ModelSelector